/**
 * MatrixModal — SIM (Self-Improvement Mode) confirmation dialog.
 */

import React from "react";
import { useTranslation } from "react-i18next";

const MatrixModal = ({ visible, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/30 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden">
        <div className="p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-2">
            {t("selfImprovementMode")}
          </h2>
          <p className="text-sm text-gray-500 mb-5">
            {t("activateSelfImprovement")}
          </p>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={onCancel}
            >
              {t("cancel")}
            </button>
            <button
              type="button"
              className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-gray-900 hover:bg-gray-800 transition-colors cursor-pointer"
              onClick={onConfirm}
            >
              {t("start")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { MatrixModal };
